import { render, staticRenderFns } from "./ProductsDraggableList.vue?vue&type=template&id=59af4b53&"
import script from "./ProductsDraggableList.vue?vue&type=script&lang=js&"
export * from "./ProductsDraggableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports